module.exports = __webpack_public_path__ + "static/media/English_US_Bob BG-35.d332353b.png";